import React from "react";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import MenuFrame from "../frames/menu_frame";

const Products = () => {
  return (
    <MenuFrame login={false}>
      <Box sx={{ minHeight: "100vh"}} >
        <Box sx={{textAlign:"center", mb:4}} >
          <motion.div initial={{ y: 20 }} animate={{ y: 0 }} transition={{ type: "spring", duration: 1 }}>
            <Typography variant="h2" sx={{ fontWeight: "bold", color: "text.primary", mb: 2 }} >
              Powerful SMS API for Seamless Communication
            </Typography>
            <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", margin: "0 auto" }}>
              Simplify your messaging needs with our robust and easy-to-integrate
              SMS API. Send messages securely, quickly, and reliably at scale.
            </Typography>
          </motion.div>
          <Button variant="contained" color="primary" size="large" sx={{ mt: 4, backgroundColor: "#007BFF", padding: "0.8rem 2rem" }} >
            Get Started
          </Button>
        </Box>
        {[
          {
            title: "Fast Integration",
            description:
              "Integrate our API in minutes with detailed documentation and easy-to-follow guides.",
          },
          {
            title: "Reliable Delivery",
            description:
              "Ensure your messages reach their destination with our highly reliable delivery network.",
          },
          {
            title: "Scalable Solutions",
            description:
              "Scale effortlessly with our API, handling millions of messages per day.",
          },
        ].map((card, index) => (
          <Grid sx={{ xs: 12, sm: 6, md: 4, pt: 4 }} key={index} >
            <motion.div initial={{ scale: 0.5 }} animate={{ scale: 1 }} transition={{ delay: 0.1 * index }} whileHover={{ scale: 1.05 }}>
              <Card sx={{ pb: 2, backgroundColor: "background.paper", borderRadius: "16px", boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)", }} >
                <CardHeader
                  title={
                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#007BFF" }} >
                      {card.title}
                    </Typography>
                  }
                />
                <CardContent>
                  <Typography variant="body1" sx={{ color: "text.secondary", lineHeight: 1.6 }} >
                    {card.description}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Box>
    </MenuFrame>
  );
};

export default Products;
